<template>
  <div ref="wrapperRef" class="wd-sticky wd-top-16 wd-z-smartBannerMobile" :style="wrapperStyle">
    <div ref="smartBannerMobile" class="smartbanner__container wd-px-5 wd-pt-3 wd-text-orange50" :style="containerStyle">
      <div class="wd-flex wd-items-start wd-justify-between" :class="isSmallVersion ? 'wd-mb-2' : 'wd-mb-4'">
        <span class="wd-mr-2 wd-text-otempmd wd-font-bold">{{ $t('app_download_promo_title') }}</span>
        <v-btn class="wd--my-2 wd--mr-5 !wd-text-orange50" :width="40" :height="40" variant="text" @click="doCloseIcon">
          <!-- TODO: migrate cancel-icon_black.svg, cancel-icon_white.svg, and cancel-icon.svg to cancel-icon_official.svg -->
          <FunnowSvgIcon class="wd-w-6 wd-h-6" width="24" max-width="24" image-path="cancel-icon_official.svg" />
        </v-btn>
      </div>

      <div class="wd-flex wd-justify-between">
        <div class="float-left wd-mr-3">
          <p v-if="!isSmallVersion" class="wd-text-otempsm wd-font-medium">{{ downloadPromoText }}</p>
          <v-btn
            class="wd-mb-3 !wd-px-3 !wd-py-1 !wd-h-auto text-white"
            style="min-width: unset !important"
            color="orange50"
            elevation="0"
            variant="flat"
            @click="downloadApp"
          >
            <span class="wd-text-omd">{{ $t('download_app') }}</span>
          </v-btn>
        </div>

        <div v-show="!isSmallVersion" class="float-right wd-flex">
          <v-img class="wd-self-end" width="120" height="120" :src="smartBannerImgPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useNewUserGift } from '@/composition/useNewUserGift'
import { useHasSmartBannerClosedCookie } from '@/composition/useAppCookie'
import { useDownloadLinks } from '@/composition/useConst'

import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import newUserGiftsSvg from '@/assets/images/funnow/new_user_gifts.svg?url'

export default defineComponent({
  name: 'SmartBannerMobile',
  components: {
    FunnowSvgIcon,
  },
  setup() {
    const isMounted = useMounted()
    const { downloadPromoText, smartBannerImgPath } = useNewUserGift()
    const { unifiedLink } = useDownloadLinks()
    const hasSmartBannerClosed = useHasSmartBannerClosedCookie()
    const { y: windowScrollY } = useWindowScroll()
    const wrapperRef = useTemplateRef<HTMLElement>('wrapperRef')
    const smartBannerMobile = useTemplateRef<HTMLElement>('smartBannerMobile')
    const { height: wrapperHeight } = useElementSize(wrapperRef, undefined, { box: 'border-box' })
    const { height: smartBannerHeight } = useElementSize(smartBannerMobile, undefined, { box: 'border-box' })

    const isSmallVersion = computed(() => windowScrollY.value !== 0)
    const wrapperStyle = computed(() => {
      const height = isSmallVersion.value ? Math.max(wrapperHeight.value, smartBannerHeight.value) : smartBannerHeight.value

      return { height: isMounted.value ? `${height}px` : 'auto' }
    })
    const containerStyle = computed(() =>
      isSmallVersion.value
        ? {
            backgroundSize: '120px',
            backgroundPosition: 'bottom 0 right 20px',
            backgroundImage: `url(${newUserGiftsSvg})`,
          }
        : {}
    )

    function downloadApp() {
      window.open(unifiedLink.value, '_blank')
    }

    function doCloseIcon() {
      hasSmartBannerClosed.value = true
    }

    return {
      isSmallVersion,
      wrapperStyle,
      containerStyle,
      doCloseIcon,
      downloadPromoText,
      downloadApp,
      getAssetsPath,
      smartBannerImgPath,
    }
  },
})
</script>

<style lang="scss" scoped>
.smartbanner__container {
  width: 100vw;
  background-color: $orange10;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
</style>
